/**
 * Converts a numerical amount to Indian English words representation.
 * Example: 44690 -> "Forty Four Thousand Six Hundred Ninety Rupees Only"
 */
export function numberToWords(num: number): string {
  if (isNaN(num) || num === 0) {
    return 'Zero Rupees Only'
  }

  const ones = [
    '',
    'One',
    'Two',
    'Three',
    'Four',
    'Five',
    'Six',
    'Seven',
    'Eight',
    'Nine',
    'Ten',
    'Eleven',
    'Twelve',
    'Thirteen',
    'Fourteen',
    'Fifteen',
    'Sixteen',
    'Seventeen',
    'Eighteen',
    'Nineteen',
  ]

  const tens = [
    '',
    '',
    'Twenty',
    'Thirty',
    'Forty',
    'Fifty',
    'Sixty',
    'Seventy',
    'Eighty',
    'Ninety',
  ]

  const convertLessThanThousand = (n: number): string => {
    if (n === 0) return ''
    if (n < 20) return ones[n]
    if (n < 100) {
      return tens[Math.floor(n / 10)] + (n % 10 !== 0 ? '-' + ones[n % 10] : '')
    }
    return (
      ones[Math.floor(n / 100)] +
      ' Hundred' +
      (n % 100 !== 0 ? ' ' + convertLessThanThousand(n % 100) : '')
    )
  }

  let rupees = Math.floor(Math.abs(num))
  const paise = Math.round((Math.abs(num) - rupees) * 100)

  let words = ''

  if (rupees >= 10000000) {
    words += convertLessThanThousand(Math.floor(rupees / 10000000)) + ' Crore '
    rupees %= 10000000
  }
  if (rupees >= 100000) {
    words += convertLessThanThousand(Math.floor(rupees / 100000)) + ' Lakh '
    rupees %= 100000
  }
  if (rupees >= 1000) {
    words += convertLessThanThousand(Math.floor(rupees / 1000)) + ' Thousand '
    rupees %= 1000
  }
  if (rupees > 0) {
    words += convertLessThanThousand(rupees) + ' '
  }

  words = words.trim() + ' Rupees'

  if (paise > 0) {
    words += ' and ' + convertLessThanThousand(paise) + ' Paise'
  }

  return words + ' Only'
}

/**
 * Formats a number into Indian Currency format (e.g. 44690 -> "44,690.00")
 */
export function formatIndianCurrency(amount: number): string {
  return new Intl.NumberFormat('en-IN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount)
}
